var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProformaInvoicesReceivedTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.834,
    cy: 19.147,
    r: 1.445
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.532 27.129V10.706a5.669 5.669 0 00-5.669-5.669H13.657a5.669 5.669 0 00-5.669 5.669v26.348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.988 37.053l4.397-4.13 4.442 4.172 4.442-4.172 4.396 4.13 4.431-4.162 4.436 4.167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.423 19.113h-7.349M23.003 23.155l-4.043-4.042 4.043-4.043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProformaInvoicesReceivedTax);
export default __webpack_public_path__ + "static/media/proformaInvoicesReceivedTax.a750a91e3eb971c9ad86596a001ec4dd.svg";
export { ForwardRef as ReactComponent };